// extracted by mini-css-extract-plugin
export default {"wrapper":"_y-z","viewport":"az-z","container":"bz-z","slide":"cz-z"};